var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_c('div',[_vm._v("版权所有："+_vm._s(_vm.library.copyright))]),_c('div',{staticStyle:{"margin-left":"48px"}},[_vm._v("技术支持："+_vm._s(_vm.library.techSupport))])])
}
var staticRenderFns = []

export { render, staticRenderFns }